export default __webpack_public_path__ + "static/media/Bow of the Clay.5cba3359.jpg";